import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "g1g-app"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Footer = _resolveComponent("Footer");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(), _createBlock(_resolveDynamicComponent($setup.CurrentRoute))), _createElementVNode("main", null, [_renderSlot(_ctx.$slots, "default")]), $setup.isFooterShow ? (_openBlock(), _createBlock(_component_Footer, {
    key: 0
  })) : _createCommentVNode("", true)]);
}